// import { useRouter } from 'next/router'
// import { MICRO_APP_MAP } from '@/constants'
// import MicroLayout from './components/MicroAppLayout'

export default ({ children }: any) => {
  // const router = useRouter()

  // if (router.pathname !== MICRO_APP_MAP.VE) {
  //   return children
  // }
  // return <MicroLayout>{children}</MicroLayout>

  return children
}
